import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./nativeReturn.scss";

const CvsNativeReturn = () => {
  const { result } = useParams<{ result: "ok" | "cancel" }>();

  const returnToApp = useCallback(() => {
    if (result === "ok" || result === "cancel") {
      window.location.href = `narashi-app://cvs-payment?result=${result}`;
    }
  }, [result]);

  useEffect(() => {
    returnToApp();
  }, [returnToApp]);

  return (
    <main className="cvs-native-return">
      <div className="cvs-native-return__content" role="status" aria-live="polite">
        <span className="cvs-native-return__spinner" aria-hidden="true" />
        <p>アプリに戻っています…</p>
        <button type="button" onClick={returnToApp}>
          アプリに戻る
        </button>
      </div>
    </main>
  );
};

export default CvsNativeReturn;
